/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown>, date: NonNullable<unknown> }} Sub_Addons_Pages_Schedule_ChangeInputs */



/**
* | output |
* | --- |
* | "Your pages add-on will change to {label} on {date}. Select your current tier to cancel, or pick a different tier." |
*
* @param {Sub_Addons_Pages_Schedule_ChangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_pages_schedule_change = /** @type {((inputs: Sub_Addons_Pages_Schedule_ChangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Pages_Schedule_ChangeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ihr Seiten-Add-on wechselt am ${i?.date} zu ${i?.label}. Wählen Sie Ihren aktuellen Tarif zum Abbrechen oder einen anderen Tarif.`)
	return /** @type {LocalizedString} */ (`Your pages add-on will change to ${i?.label} on ${i?.date}. Select your current tier to cancel, or pick a different tier.`)
});